import React, { Component } from 'react'

import PageTitleBasic from '../../../components/ui/typography/PageTitleBasic'

class termsAndConditions extends Component {
  render() {
    return (
      <div>
        <div className="max-800">
          <PageTitleBasic content="About Steppingblocks" />
          <h5>General</h5>
          <p>
            Steppingblocks does its best to provide attribution where
            applicable. Many sources are attributed next to the source display
            with a link to the original source. Other content receives
            attribution on this page.{' '}
          </p>
          <br />
          <h5>Animated Loaders</h5>
          <p>
            All loaders used in Steppingblocks are distributed under Creative
            Commons (CC) Attribution (BY) unless stated otherwise. 'Gears' and
            'Emoji Shock' provided by @PixelBuddha. 'Cloud Disconnection'
            provided by an anonymous lottie user. 'Graduation Engineer' provided
            by Lucas Nemo.{' '}
          </p>
          <br />
          <br />
          <h5>Graphic Image Files (GIFs)</h5>
          <p>
            All GIFs used by Steppingblocks are served via GIPHY
            (www.giphy.com).
          </p>
          <br />
        </div>
      </div>
    )
  }
}

export default termsAndConditions



// WEBPACK FOOTER //
// ./src/routes/authenticated/About/AuthenticatedAboutIndex.js